var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.25H40.5V40.5H20.25V20.25Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 0V60.75H0V0H60.75ZM50.625 10.125H10.125V50.625H50.625V10.125ZM40.5 121.5H20.25V141.75H40.5V121.5Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 101.25V162H0V101.25H60.75ZM10.125 111.375V151.875H50.625V111.375H10.125ZM121.5 20.25H141.75V40.5H121.5V20.25Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 0V60.75H162V0H101.25ZM151.875 10.125V50.625H111.375V10.125H151.875ZM81 10.125V0H91.125V20.25H81V40.5H70.875V10.125H81ZM81 60.75V40.5H91.125V60.75H81ZM60.75 81V70.875H70.875V60.75H81V81H91.125V70.875H141.75V81H101.25V91.125H70.875V81H60.75ZM60.75 81V91.125H20.25V81H10.125V91.125H0V70.875H30.375V81H60.75ZM162 91.125H151.875V70.875H162V91.125ZM151.875 91.125H141.75V111.375H162V101.25H151.875V91.125ZM111.375 91.125H131.625V101.25H121.5V111.375H111.375V91.125ZM131.625 121.5V111.375H121.5V121.5H111.375V131.625H91.125V141.75H121.5V121.5H131.625ZM131.625 121.5H162V131.625H141.75V141.75H131.625V121.5ZM91.125 111.375V121.5H101.25V101.25H70.875V111.375H91.125Z",
    fill: "#545454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.875 121.5H81V151.875H121.5V162H70.875V121.5ZM162 141.75V162H131.625V151.875H151.875V141.75H162Z",
    fill: "#545454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.4c2b4ae1b21800db92f9e6239131acdf.svg";
export { ForwardRef as ReactComponent };